<template>
    <div class="business">
        <Header ref="header" :title="title" @backPage="onBack"></Header>
        <div class="content">
            <dl class="uploadtips" v-show="stepV===1">
                <dt>上传本人身份证照片</dt>
                <dd>1、请上传本人的身份证照片（最新的，彩色的）</dd>
                <dd>2、拍照是请确保身份证边框完整，图像清晰，光线均匀</dd>
            </dl>
            <dl class="uploadtips" v-show="step===1">
                <dt>上传法人身份证照片</dt>
                <dd>1、请上传法人的身份证照片（最新的，彩色的）</dd>
                <dd>2、拍照是请确保身份证边框完整，图像清晰，光线均匀</dd>
            </dl>
            <dl class="uploadtips" v-show="step===2">
                <dt>上传企业营业照片</dt>
                <dd>1、请上传企业营业执照（最新的，彩色的）</dd>
                <dd>2、拍照是请确保营业执照边框完整，图像清晰，光线均匀</dd>
            </dl>
            <!-- <button @click="onTest('certPhotoA', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200813/25b145c4-3046-453a-98d3-3a67e12ee549.jpg')">正面</button>
            <button @click="onTest('certPhotoB', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200915/7656725a-1cea-4236-ab95-7c75ba8eb353.jpg')">反面</button>
            <button @click="onTest('businessLicensePhoto', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20200813/1fd0bae3-3776-4f96-9664-91e4a889abea.jpg')">营业</button>
            <button @click="onTest('openingPermitPhoto', 'https://hosjoy-oss-test.oss-cn-hangzhou.aliyuncs.com/images/20201118/4614ebcd-e757-42cf-9c74-3f8467f77659.jpg')">开户</button> -->
            <div class="uploadarea" v-show="step===1||stepV===1">
                <div class="cert certPhotoA">
                    <span>身份证人像面照片</span>
                    <input :class="certPhotoA?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'certPhotoA')">
                    <img :src="certPhotoA?certPhotoA:defCertPhotoAUrl" preview="2" preview-text="身份证正面" style="posttion: relative;z-index:10">
                </div>
                <div class="cert certPhotoB">
                    <span>身份证国徽面照片</span>
                    <input :class="certPhotoB?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'certPhotoB')">
                    <img :src="certPhotoB?certPhotoB:defCertPhotoBUrl" preview="2" preview-text="身份证正面" style="posttion: relative;z-index:10">
                </div>
            </div>
            <div class="uploadarea"  v-show="step===2">
                <div class="cert license">
                    <span>营业执照照片</span>
                    <input :class="businessLicensePhoto?'lowZIndex':''" type="file" accept="image/*" id="upload" name="upload" @click="getPhoto($event, 'businessLicensePhoto')">
                    <img :src="businessLicensePhoto?businessLicensePhoto:defLicensePhotoUrl" preview="1" preview-text="营业执照照片" style="posttion: relative;z-index:10">
                </div>
            </div>
            <div class="card f28 bgFFFFFF info" v-show="stepV===2">
                <van-field
                        v-model="individual.userName"
                        required
                        maxlength = '50'
                        label="姓名"
                        placeholder="请输入姓名"
                />
                <van-field
                        v-model="individual.credentialNumber"
                        type="tel"
                        required
                        maxlength = '50'
                        label="身份证号"
                        placeholder="请输入身份证号码"
                />
                <van-field
                        v-model="startTime"
                        type="tel"
                        required
                        @click="onPopupDate(1)"
                        maxlength = '11'
                        label="身份证发证日期"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择身份证发证日期"
                />
                <van-field
                        v-model="endTime"
                        type="tel"
                        required
                        @click="onPopupDate(2)"
                        maxlength = '11'
                        label="身份证到期日期"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择身份证到期日期"
                />
                <van-field
                        v-model="individual.indAddress"
                        type="tel"
                        required
                        @click="onArea"
                        maxlength = '11'
                        label="经营区域"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择您的经营区域"
                />
                <van-checkbox v-model="checked" shape="square" v-show="!bankShow" label-disabled>
                    <span @click="popupVisible = true">同意协议</span>
                </van-checkbox>
            </div>
            <div class="card f28 bgFFFFFF info"  v-show="step===3">
                <van-field
                        v-model="corporation.legalPersonName"
                        required
                        maxlength = '50'
                        label="法人代表"
                        placeholder="请输入法人代表"
                />
                <van-field
                        v-model="corporation.legalCredentialNumber"
                        type="tel"
                        required
                        maxlength = '50'
                        label="法人代表身份证号"
                        placeholder="请输入身份证号码"
                />
                <van-field
                        v-model="startTime"
                        type="tel"
                        required
                        @click="onPopupDate(1)"
                        maxlength = '11'
                        label="身份证发证日期"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择身份证发证日期"
                />
                <van-field
                        v-model="endTime"
                        type="tel"
                        required
                        @click="onPopupDate(2)"
                        maxlength = '11'
                        label="身份证到期日期"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择身份证到期日期"
                />
                <van-field
                        v-model="corporation.corporationName"
                        required
                        maxlength = '50'
                        label="企业全称"
                        placeholder="请输入企业名全称"
                />
                <van-field
                        v-model="corporation.unifiedSocialCreditCode"
                        required
                        maxlength = '18'
                        label="统一社会信用代码"
                        placeholder="请输入统一社会信用代码"
                />
                <van-field
                        v-model="corporation.corAddress"
                        type="tel"
                        required
                        @click="onArea"
                        maxlength = '11'
                        label="经营区域"
                        :readonly = 'true'
                        right-icon="question-o"
                        placeholder="请选择您的经营区域"
                />
                <van-checkbox v-model="checked" shape="square" v-show="!bankShow"  label-disabled>
                    <span @click="popupVisible = true">同意协议</span>
                </van-checkbox>
            </div>
        </div>
        <div class="foot" v-show="!bankShow">
            <div class="btn" :class="{'btnDisble': !checked && stepShow}" @click="submit">{{(step===3 || stepV===2) ? '确认' : step===2 ? '下一步' : '提交'}}</div>
        </div>
        <areaList ref="area" :citiyValue='countryId' @onArea='onAreaData'></areaList>
        <Protocol :visible.sync='popupVisible'></Protocol>
        <PopupDate :visible2.sync='popupDate' @updateTime='setDateTime'></PopupDate>
    </div>
</template>
<script>
import Header from '../../common/header'
import areaList from '../common/area'
import Protocol from './protocol'
import PopupDate from '../common/PopupDate'
import { getOcrFromBL, getOcrFromID } from '../../b2b/api/api.js'
import { postAuth } from '../../b2b/api/payment'
import { mapMutations, mapGetters } from 'vuex'
import { versions } from '../../common/version'
import { Toast, Dialog } from 'vant'
export default {
    name: 'bank',
    data () {
        return {
            title: '上传证件',
            addressName: '',
            checked: true,
            popupVisible: false,
            popupDate: false,
            bankShow: false,
            dateTime: '',
            startTime: '',
            endTime: '',
            dateType: 1, // 身份证日期
            openAccountInfo: '',
            countryId: '',
            stepShow: true,
            corporation: {
                legalPersonName: '',
                legalCredentialNumber: '',
                corporationName: '',
                unifiedSocialCreditCode: '',
                corAddress: '',
                corporationShort: '',
                legalPersonExpiryDate: '',
                legalPersonIssDate: '',
                allLicenceExpiryDate: '20991231',
                city: '320100',
                province: '32'
            },
            individual: {
                userName: '',
                credentialNumber: '',
                expiryDate: '',
                issDate: '',
                indAddress: ''
            },
            areaData: {
                provinceName: '',
                provinceId: '',
                cityName: '',
                cityId: '',
                countryName: '',
                countryId: ''
            },
            retailer: {
                managerName: '',
                managerCredentialNumber: '',
                retailerName: ''
            },
            companyCode: '',
            businessLicensePhoto: '',
            certPhotoA: '',
            certPhotoB: '',
            step: '',
            stepV: '',
            userType: parseInt(this.$route.query.userType) || 11,
            defCertPhotoAUrl: require('../../../assets/img/b2b/img_idcard1.png'),
            defCertPhotoBUrl: require('../../../assets/img/b2b/img_idcard2.png'),
            defLicensePhotoUrl: require('../../../assets/img/b2b/img_businesslicense.png'),
            defBusPhotoUrl: require('../../../assets/img/b2b/img_busPhoto.png')
        }
    },
    watch: {
        'corporation.corporationName': {
            handler (newName, oldName) {
                this.corporation.corporationShort = newName
            },
            deep: true
        },
        'corporation.legalPersonName': {
            handler (newName, oldName) {
                this.corporation.legalPersonName = newName.replace(/[^\u4E00-\u9FA5]/g, '')
            },
            deep: true
        }
    },
    computed: {
        ...mapGetters(['bankData'])
    },
    methods: {
        ...mapMutations({
            setBankInfo: 'SAVE_BANKINFO'
        }),
        bankSearch (val) {
            this.bankShow = val
        },
        onTest (target, url) {
            this.getOEImgUrl(target, url)
        },
        onPopupDate (type) {
            this.dateType = type
            this.popupDate = true
        },
        setDateTime (date) {
            if (this.dateType === 1) {
                this.startTime = date
            } else {
                this.endTime = date
            }
            let legalDate = date.split('-').join('')
            if (this.userType * 1 === 11 && this.dateType === 1) {
                this.individual.issDate = legalDate
            } else if (this.userType * 1 === 11 && this.dateType === 2) {
                this.individual.expiryDate = legalDate
            } else if (this.userType * 1 === 12 && this.dateType === 1) {
                this.corporation.legalPersonIssDate = legalDate
            } else if (this.userType * 1 === 12 && this.dateType === 2) {
                this.corporation.legalPersonExpiryDate = legalDate
            }
        },
        onArea () {
            this.$refs.area.onShow()
        },
        onAreaData (data) {
            this.individual.indAddress = data.addressName
            this.corporation.corAddress = data.addressName
            this.areaData = data
        },
        async submit () {
            if (!this.checked && this.stepShow) {
                Toast('请勾选同意协议')
                return
            }
            const idcardReg = /^[1-9]\d{7}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}$|^[1-9]\d{5}[1-9]\d{3}((0\d)|(1[0-2]))(([0|1|2]\d)|3[0-1])\d{3}([0-9]|X)$/
            const creditCodeReg = /[0-9A-HJ-NPQRTUWXY]{2}\d{6}[0-9A-HJ-NPQRTUWXY]{10}/
            let startTime = new Date(this.startTime).getTime()
            let endTime = new Date(this.endTime).getTime()
            if (this.userType * 1 === 11) {
                if (this.stepV === 2) {
                    if (!this.individual.userName) {
                        Toast('请填写姓名')
                        return
                    }
                    if (!idcardReg.test(this.individual.credentialNumber)) {
                        Toast('身份证号有误，请重填')
                        return
                    }
                    if (!this.individual.issDate) {
                        Toast('请选择身份证发证日期')
                        return
                    }
                    if (this.individual.issDate.length !== 8) {
                        Toast('身份证发证日期有误,请重新选择')
                        return
                    }
                    if (!this.dateCheck(this.startTime)) {
                        Toast('身份证发证日期有误,请重新选择')
                        return
                    }
                    if (!this.individual.expiryDate) {
                        Toast('请选择身份证到期日期')
                        return
                    }
                    if (this.individual.expiryDate.length !== 8) {
                        Toast('身份证到期日期有误,请重新选择')
                        return
                    }
                    if (!this.dateCheck(this.endTime)) {
                        Toast('身份证到期日期有误,请重新选择')
                        return
                    }
                    if (startTime > endTime) {
                        Toast('发证日期不得大于到期日期')
                        return
                    }
                    if (!this.individual.indAddress) {
                        Toast('请选择经营地址')
                        return
                    }
                    this.jumpLink()
                } else if (this.stepV === 1) {
                    if (!this.certPhotoA) {
                        Toast('请上传身份证正面')
                        return
                    }
                    if (!this.certPhotoB) {
                        Toast('请上传身份证反面')
                        return
                    }
                    if (!this.checked) {
                        this.stepShow = true
                    }
                    this.title = '实名认证'
                    this.stepV++
                }
            } else if (this.userType * 1 === 12 || this.userType * 1 === 13) {
                if (this.step === 3) {
                    if (!this.corporation.legalPersonName) {
                        Toast('请输入法人代表')
                        return
                    }
                    if (!this.corporation.legalCredentialNumber) {
                        Toast('请输入身份证号码')
                        return
                    }
                    if (!idcardReg.test(this.corporation.legalCredentialNumber)) {
                        Toast('身份证号有误，请重填')
                        return
                    }
                    if (!this.corporation.legalPersonIssDate) {
                        Toast('请选择身份证发证日期')
                        return
                    }
                    if (this.corporation.legalPersonIssDate.length !== 8) {
                        Toast('身份证发证日期有误,请重新选择')
                        return
                    }
                    if (!this.dateCheck(this.startTime)) {
                        Toast('身份证发证日期有误,请重新选择')
                        return
                    }
                    if (!this.corporation.legalPersonExpiryDate) {
                        Toast('请选择身份证到期日期')
                        return
                    }
                    if (this.corporation.legalPersonExpiryDate.length !== 8) {
                        Toast('身份证到期日期有误,请重新选择')
                        return
                    }
                    if (!this.dateCheck(this.endTime)) {
                        Toast('身份证到期日期有误,请重新选择')
                        return
                    }
                    if (startTime > endTime) {
                        Toast('发证日期不得大于到期日期')
                        return
                    }
                    if (!this.corporation.corporationName) {
                        Toast('请输入企业名称')
                        return
                    }
                    if (!creditCodeReg.test(this.corporation.unifiedSocialCreditCode)) {
                        Toast('社会信用代码输入有误，请重填')
                        return
                    }
                    if (this.corporation.unifiedSocialCreditCode.indexOf('91') !== 0) {
                        Toast('目前仅支持企业认证，个体工商户等组织不允许认证')
                        return
                    }
                    if (!this.corporation.corAddress) {
                        Toast('请选择经营地址')
                        return
                    }
                    this.jumpLink()
                } else if (this.step === 2) {
                    if (!this.businessLicensePhoto) {
                        Toast('请上传营业执照照片')
                        return
                    }
                    if (!this.checked) {
                        this.stepShow = true
                    }
                    this.title = '实名认证'
                    this.step++
                } else {
                    if (!this.certPhotoA) {
                        Toast('请上传身份证正面')
                        return
                    }
                    if (!this.certPhotoB) {
                        Toast('请上传身份证反面')
                        return
                    }
                    this.step++
                }
            }
        },
        dateCheck (date) {
            return (new Date(date).getDate() == date.substring(date.length - 2))
        },
        getPhoto (e, n) {
            e.preventDefault()
            this.onClickGetImg(n)
        },
        onClickGetImg (target) {
            if (versions().ios || versions().iPhone || versions().iPad) {
                window.webkit.messageHandlers.dfxB2b.postMessage({
                    'method': 'callPhoto',
                    'target': target
                })
            } else {
                window.kfxt.callPhoto(target)
            }
        },
        async getOEImgUrl (tag, url) {
            Toast.loading({
                message: '图片上传中...',
                forbidClick: true,
                duration: 0
            })
            this[tag] = url
            if (tag === 'businessLicensePhoto') {
                this.getOcrFromBL(tag, url)
            } else {
                this.getOcrFromID(tag, url)
            }
        },
        async getOcrFromBL (tag, image) {
            const { data } = await getOcrFromBL({ image })
            Toast.clear()
            if (tag === 'businessLicensePhoto' && !data.enterpriseNameCh) {
                this.checkOut(tag)
                return false
            }
            if (this.userType * 1 === 12) {
                this.corporation.corporationName = data.enterpriseNameCh || ''
                this.corporation.unifiedSocialCreditCode = data.enterpriseId || ''
            }
        },
        async getOcrFromID (tag, image) {
            let startDate = ''
            let endDate = ''
            const { data } = await getOcrFromID({ image })
            Toast.clear()
            if (tag === 'certPhotoA' && !data.personName) {
                this.checkOut(tag)
                return false
            }
            if (tag === 'certPhotoB' && !data.timeZone) {
                this.checkOut(tag)
                return false
            }
            if (data.timeZone) {
                let dateTime = data.timeZone.split('-')
                startDate = dateTime[0].split('.').join('')
                endDate = dateTime[1] == '长期' ? '20991231' : dateTime[1].split('.').join('')
                this.endTime = dateTime[1] == '长期' ? '2099-12-31' : dateTime[1].split('.').join('-')
                this.startTime = dateTime[0].split('.').join('-')
            }
            if (this.userType * 1 === 11) {
                if (tag === 'certPhotoA') {
                    this.individual.userName = data.personName || ''
                    this.individual.credentialNumber = data.personId || ''
                } else {
                    this.individual.expiryDate = endDate || ''
                    this.individual.issDate = startDate || ''
                }
            } else if (this.userType * 1 === 12) {
                if (tag === 'certPhotoA') {
                    this.corporation.legalPersonName = data.personName || ''
                    this.corporation.legalCredentialNumber = data.personId || ''
                } else {
                    this.corporation.legalPersonExpiryDate = endDate || ''
                    this.corporation.legalPersonIssDate = startDate || ''
                }
            }
        },
        checkOut (tag, context) {
            Dialog.alert({
                title: '图片识别失败',
                message: tag === 'businessLicensePhoto' ? '请上传清晰的营业照照片，以便于准确识别内容。' : '请上传清晰的身份证照片，以便于准确识别内容。',
                confirmButtonText: '重新上传',
                closeOnClickOverlay: true
            }).then(() => {
                this[tag] = ''
                this.onClickGetImg(tag)
            }).catch(() => {
                this[tag] = ''
            })
        },
        onBack () {
            let _this = this
            if (this.bankShow) {
                this.$refs.banks.bankshow()
                return false
            }
            if ((this.userType * 1 === 11) && (this.stepV !== 1)) {
                this.stepV--
                if (this.stepV < 2 && !this.checked) {
                    this.stepShow = false
                }
                return
            }
            if ((this.userType * 1 === 12) && (this.step !== 1)) {
                this.step--
                if (this.step < 3 && !this.checked) {
                    this.stepShow = false
                }
                return
            }
            Dialog.confirm({
                title: '提示',
                message: '返回后认证流程将中断'
            }).then(() => {
                _this.$router.go(-1)
            })
        },
        async jumpLink () {
            const { companyCode, userType, certPhotoA, certPhotoB, businessLicensePhoto, individual, corporation, areaData } = this
            Toast.loading({
                message: '提交中...',
                forbidClick: true,
                duration: 0
            })
            let res = ''
            if (userType * 1 === 11) {
                res = await postAuth({ individual: { ...individual, certPhotoA, certPhotoB }, companyCode, userType, ...areaData })
            } else if (userType * 1 === 12 || userType * 1 === 13) {
                res = await postAuth({ corporation: { ...corporation, certPhotoA, certPhotoB, businessLicensePhoto }, companyCode, userType, ...areaData })
            }
            const { data: { isCertified, message } } = res
            Toast.clear()
            if (isCertified === '0') {
                Toast(message)
                return false
            }
            this.$router.push({ path: '/b2b/business/approveResult', query: { userType } })
        },
        getTime (dataTime) {
            if (!dataTime) {
                return false
            }
            return dataTime.substr(0, 4) + '-' + dataTime.substr(4, 2) + '-' + dataTime.substr(6)
        }
    },
    mounted () {
        let userInfo = JSON.parse(localStorage.getItem('userInfo'))
        let areaInfo = JSON.parse(localStorage.getItem('areaInfo'))
        this.companyCode = userInfo.companyCode
        this.countryId = areaInfo.countryId
        this.areaData = {
            provinceName: areaInfo.provinceName,
            provinceId: areaInfo.provinceId,
            cityName: areaInfo.cityName,
            cityId: areaInfo.cityId,
            countryName: areaInfo.countryName,
            countryId: areaInfo.countryId
        }
        if (this.userType * 1 === 11) {
            this.stepV = 1
            this.individual.indAddress = areaInfo.provinceName + ' ' + areaInfo.cityName + ' ' + areaInfo.countryName
        } else {
            this.step = 1
            this.corporation.corAddress = areaInfo.provinceName + ' ' + areaInfo.cityName + ' ' + areaInfo.countryName
        }
        window.getOEImgUrl = (tag, url) => {
            this.getOEImgUrl(tag, url)
        }
    },
    components: {
        Header,
        areaList,
        Protocol,
        PopupDate
    }
}
</script>
<style lang="scss" scoped>
    .business{
        height: 100%;

    }
    .foot {
        padding: 32px;
        font-size: 28px;
        .btn {
            width: 100%;
            height: 96px;
            line-height: 96px;
            border-radius: 96px;
            background: #ff7a45;
            color: #ffffff;
            text-align: center;
            cursor: pointer;
        }
        .btnDisble {
            background: #cccccc;
        }
        .xy {
            text-align: center;
            margin-top: 20px;
            margin-bottom: 26px;
            color: #999999;
            span {
                color: #ff7a45;
            }
        }
    }
    .content {
        background: #ffffff;
        .uploadtips{
            padding: 32px;
            dt{
                color: #000;
                font-size: 36px;
                margin-bottom: 16px;
            }
            dd{
                font-size: 24px;
                color: #999;
            }
        }
        .uploadarea{
            padding: 32px;
            .cert{
                position: relative;
                width: 686px;
                span{
                    color: #666;
                    font-size: 26px;
                    display: block;
                    margin-bottom: 15px;
                }
                input{
                    position: absolute;
                    width: 686px;
                    height: 386px;
                    opacity: 0;
                }
                img{
                    width: 686px;
                    height: 386px;
                }
            }
            .certPhotoB{
                margin-top: 48px;
            }
            .license{
                input{
                    height: 514px;
                }
                img{
                    height: 514px;
                }
            }
            .bus {
                input{
                    height: 914px;
                }
                img{
                    height: 914px;
                }
            }
        }
        .card {
            margin-bottom: 20px;
            .item {
                position: relative;
                display: flex;
                justify-content: space-between;
                padding: 32px;
                .item-left {
                    position: relative;
                    .positionRight {
                        line-height: 0;
                        position: absolute;
                        top: calc(50% - 16px);
                        right: -40px;
                        width: 32px;
                        height: 32px;
                    }
                    .BankTips::before {
                        content: "";
                        position: absolute;
                        bottom: -20px;
                        left: 123px;
                        display: inline-block;
                        width: 0;
                        height: 0;
                        border: 10px solid;
                        border-color: #ff7a45 transparent transparent;
                    }
                    .BankTips {
                        padding: 10px;
                        position: absolute;
                        width: 336px;
                        height: 50px;
                        line-height: 50px;
                        left: 0;
                        bottom: 80px;
                        color: #333333;
                        border: 2px solid #ff7a45;
                        background-color: #fff9f5;
                    }
                }
                .item-right {
                    position: relative;
                    &.paddingRight60 {
                        padding-right: 60px;
                    }
                    &.paddingRight210 {
                        padding-right: 210px;
                    }
                    .edit {
                        line-height: 0;
                        position: absolute;
                        right: 0;
                        top: calc(50% - 19px);
                        width: 40px;
                        height: 40px;
                        z-index: 2;
                        img {
                            width: 100%;
                            height: 100%;
                        }
                    }
                    .code {
                        position: absolute;
                        text-align: center;
                        right: 0;
                        top: calc(50% - 19px);
                        width: 190px;
                        height: 40px;
                        border-radius: 10px;
                    }
                    .verCode {
                        background-color: #ff7a45;
                        color: #ffffff;
                    }
                    .disverCode {
                        background-color: #999999;
                        color: #ffffff;
                    }
                    input[type="text"] {
                        text-align: right;
                    }
                    .delete {
                        background-image: url("../../../assets/img/b2b/icon-delete.png");
                        background-repeat: no-repeat;
                        background-size: cover;
                        position: absolute;
                        width: 40px;
                        height: 40px;
                        top: -20px;
                        left: -20px;
                    }
                    .arrow {
                        position: relative;
                    }
                }
                &.borderBot::before {
                    width: auto;
                }
                &.itemPic {
                    padding: 32px;
                    .item-right {
                        position: relative;
                        padding-right: 0;
                        input {
                            position: absolute;
                            right: 0;
                            top: 0;
                            width: 128px;
                            height: 128px;
                            border: none;
                            opacity: 0;
                        }
                        .lowZIndex {
                            z-index: -1;
                        }
                        img {
                            display: block;
                            width: 128px;
                            height: 128px;
                        }
                    }
                }
                &.morePic {
                    .item-right {
                        .item-flex {
                            width: 288px;
                            margin-bottom: 32px;
                            display: flex;
                            justify-content: space-between;
                            .container {
                                position: relative;
                            }
                        }
                    }
                }
            }
            .flex {
                display: flex;
                justify-content: space-around;
            }
        }
        .info{
            background: #ffffff;
            padding-left: 32px;
            font-size: 28px;
        }
    }
    .van-checkbox {
        padding: 24px 0;
    }
    /deep/ .van-checkbox__label {
        line-height: inherit;
        font-size: 24px;
        margin-left: 20px;
        span{
            text-decoration: underline;
        }
    }
    /deep/ .van-checkbox__icon {
        font-size: 24px;
    }
    /deep/ .van-checkbox__icon .van-icon{
        font-size: 24px;
    }
    /deep/ .van-cell{
        align-items: center;
    }
    /deep/ .van-button--normal {
        width: 100%;
        height: 96px;
        line-height: 96px;
        font-size: 32px;
    }
    /deep/ .van-button--default{
        border: 2px solid rgb(255, 122, 69);
    }
    /deep/ .van-icon-question-o:before{
        content: "\F00A";
    }
    /deep/ .van-field__right-icon {
        margin: 0 20px;
    }
    /deep/ .van-field__label{
        height: auto;
    }
</style>